module.exports = __webpack_public_path__ + "img/f-1.0fa4cce5.jpg";